<template>
  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="mx-2 mb-2 mt-1">
        <b-row>
          <b-col
            class="mt-1 mt-lg-0 d-flex align-items-end justify-content-start"
            cols="12"
            md="12"
          >
            <div class="d-flex align-items-center justify-content-end w-100">
              <b-button
                variant="primary"
                @click="downloadReport"
              >
                <span class="text-nowrap">
                  Exportar
                  <feather-icon
                    icon="DownloadIcon"
                    size="16"
                  />
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="paymentRemittanceDeleteHistory"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro correspondente encontrado"
        :sort-desc.sync="isSortDirDesc"
        @row-clicked="(item) => { item.checked = !item.checked }"
      >
        <template
          #cell(data.contract_code)="{ item }"
          class="w-100"
        >
          <div>{{ item.data.contract_code }}</div>
          <div class="row-subtitle">
            Remessa Nº{{ item.data.payment_remittance_code }}
          </div>
        </template>
        <template
          #cell(status)="{ item }"
          class="w-100"
        >
          <b-badge
            pill
            :variant="`light-${resolveDeleteStatusVariant(item.status)}`"
            class="text-capitalize"
          >
            {{ item.status === 'synchronized' ? 'Sincronizado' : 'Pendente' }}
          </b-badge>
          <div
            v-if="item.operation"
            class="row-subtitle"
          >
            OP. {{ item.operation }}
          </div>
        </template>
        <template
          #cell(data.company)="{ item }"
          class="w-100"
        >
          <b-badge
            pill
            :variant="item.data.person_type === 'PJ' ? 'light-danger' : 'light-success'"
          >
            {{ item.data.person_type || 'PF' }}
          </b-badge>
          <div>
            <strong>{{ item.data.company_name || item.data.physician_name }}</strong>
            <div>{{ item.data.company_cnpj ? formatCnpj(item.data.company_cnpj) : maskHiddenCpf2(item.data.physician_cpf) }}</div>
          </div>
        </template>
        <template
          #cell(canceled_by)="{ item }"
          class="w-100"
        >
          <div>{{ item.canceled_by }}</div>
          <div class="row-subtitle">
            {{ formatISODateTimeDDMMYYHHMMSS(item.canceled_at) }}
          </div>
        </template>
        <template
          #cell(data.value)="{ item }"
          class="w-100"
        >
          <div>{{ formatCurrencyInt(item.data.value) }}</div>
          <div class="row-subtitle">
            {{ formatDateTimeDDMMYYHHMM(item.data.start_date) }} - {{ formatDateTimeDDMMYYHHMM(item.data.end_date) }}
          </div>
        </template>
        <template
          #cell(data.institution_name)="{ item }"
          class="w-100"
        >
          <div><strong>{{ item.data.institution_name }}</strong></div>
          <div class="row-subtitle">
            {{ item.data.workplace_name }}
          </div>
        </template>
        <template
          #cell(data.physician_name)="{ item }"
          class="w-100"
        >
          <div><strong>{{ item.data.physician_name }}</strong></div>
          <div class="row-subtitle">
            CPF: {{ maskHiddenCpf2(item.data.physician_cpf) }}
          </div>
        </template>
        <template
          #cell(data.account)="{ item }"
          class="w-100"
        >
          <div class="d-flex flex-column">
            <div class="account-info">
              <div>Banco</div>
              <div>{{ item.data.account_bank_code }} - {{ item.data.account_bank_name }}</div>
            </div>
            <div class="d-flex">
              <div class="account-info">
                <div>Agência</div>
                <div>{{ item.data.branch_number }}<span v-if="item.data.branch_code">-{{ item.data.branch_code }}</span></div>
              </div>
              <div class="account-info">
                <div>{{ resolveAccountType(item.data.account_type) }}</div>
                <div>{{ item.data.account_number }}-{{ item.data.account_code }}</div>
              </div>
            </div>
          </div>
        </template>

        <template
          #cell(amount_physician_duty)="{ item }"
          class="w-100"
        >
          {{ formatCurrency(item.amount_physician_duty) }}
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BTable,
  BPagination, BBadge,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import {
  formatCnpj, formatCpf,
  formatCurrency,
  formatCurrencyInt,
  formatDateTimeDDMMYYHHMM,
  formatISODateTimeDDMMYYHHMMSS,
  maskHiddenCpf2,
  resolveAccountType,
} from '@core/utils/utils'
import reportStoreModule from '@/views/report/reportStoreModule'
import { format } from 'date-fns'
import usePaymentRemittanceDeleteHistoryList from './usePaymentRemittanceDeleteHistoryList'
import contractStoreModule from '../contractStoreModule'

export default {
  components: {
    BButton,
    BBadge,
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
  },
  directives: {
    Ripple,
  },
  methods: {
    formatCpf,
    formatCnpj,
    formatISODateTimeDDMMYYHHMMSS,
    formatCurrencyInt,
    maskHiddenCpf2,
    resolveAccountType,
  },
  setup() {
    const CONTRACT_APP_STORE_MODULE_NAME = 'app-contract'
    const REPORTS_STORE_MODULE_NAME = 'app-reports'

    // Register module
    if (!store.hasModule(CONTRACT_APP_STORE_MODULE_NAME)) store.registerModule(CONTRACT_APP_STORE_MODULE_NAME, contractStoreModule)
    if (!store.hasModule(REPORTS_STORE_MODULE_NAME)) store.registerModule(REPORTS_STORE_MODULE_NAME, reportStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(CONTRACT_APP_STORE_MODULE_NAME)) store.unregisterModule(CONTRACT_APP_STORE_MODULE_NAME)
      if (store.hasModule(REPORTS_STORE_MODULE_NAME)) store.unregisterModule(REPORTS_STORE_MODULE_NAME)
    })

    const paymentDate = ref('')
    const loading = ref(false)
    const currentUserId = ref(null)
    const paymentRemittanceModal = ref(null)
    const paymentRemittance = ref(null)
    const contractCancelModal = ref(null)
    const contractToCancel = ref({
      contract_id: '',
      motive: '',
    })

    const {
      paymentRemittanceDeleteHistory,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveDeadlineVariant,
      showImediato,

      // Extra Filters
      roleFilter,
      planFilter,
      situationFilter,
      statusFilter,
      createPaymentRemittance,
      institutionId,
      institutionOptions,
      resolveDeleteStatusVariant,
    } = usePaymentRemittanceDeleteHistoryList()

    const downloadReport = () => {
      store.dispatch(`${REPORTS_STORE_MODULE_NAME}/paymentRemittanceExportDeleteHistory`)
        .then(response => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          const now = format(new Date(), 'yyyy-MM-dd hh:mm:ss')
          link.download = `itens_removido_remessas_${now}.xlsx`
          link.click()
          URL.revokeObjectURL(link.href)
        })
    }

    return {
      downloadReport,
      contractToCancel,
      contractCancelModal,
      loading,

      paymentRemittanceDeleteHistory,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      paymentDate,
      showImediato,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveDeadlineVariant,
      resolveDeleteStatusVariant,

      currentUserId,

      // Extra Filters
      roleFilter,
      planFilter,
      situationFilter,
      statusFilter,
      formatCurrency,
      formatDateTimeDDMMYYHHMM,
      createPaymentRemittance,
      paymentRemittanceModal,
      paymentRemittance,
      institutionId,
      institutionOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.dates-row {
  max-width: 500px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';

tr:has(.custom-checkbox.checked) {
  background-color: rgba(98, 98, 98, 0.05);
}
.row-subtitle {
  font-size: 12px;
  color: #959a9c;
}
.account-info {
  display: flex;
  flex-direction: column;
  margin-right: 5px;
  div {
    font-size: 13px;
    line-height: 13px;
  }
  div:first-child {
    font-size: 10px;
    color: #959a9c;
  }
}
</style>
